import * as React from "react"
import { Flex, HStack } from "@chakra-ui/react"
import { Logo } from "./logo"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../recoil/atoms/room"
import ErrorMessage from "../common/errormessage"

const _Header = () => {
  const roomStyles = useRecoilValue(brandingSelector)

  return (
    <>
      <Flex
        height="3rem"
        justifyContent="space-between"
        bg={roomStyles?.roomHeaderColor ?? "blue.100"}
        px={4}
      >
        <Flex alignItems={"center"} justifyContent={"space-between"}>
          <HStack spacing={8} alignItems={"center"}>
            <Logo src={roomStyles?.roomHeaderIcon} />
          </HStack>
        </Flex>
      </Flex>
      <ErrorMessage />
    </>
  )
}

export const Header = React.memo(_Header)
